const SESSION_CACHE_KEY = "cinema.admin.inventory.v1";
const SESSION_CACHE_MAX_AGE_MS = 6 * 60 * 60 * 1000;

export function readAdminInventoryCache() {
  for (const storage of [window.sessionStorage, window.localStorage]) {
    try {
      const cached = JSON.parse(storage.getItem(SESSION_CACHE_KEY));
      if (
        cached &&
        Array.isArray(cached.data) &&
        Date.now() - Number(cached.savedAt || 0) <= SESSION_CACHE_MAX_AGE_MS
      ) {
        return cached.data;
      }
    } catch (error) {
      console.debug("Admin inventory cache unavailable:", error?.message);
    }
  }

  return [];
}

export function writeAdminInventoryCache(data) {
  if (!Array.isArray(data)) return;

  const serialized = JSON.stringify({ data, savedAt: Date.now() });
  for (const storage of [window.sessionStorage, window.localStorage]) {
    try {
      storage.setItem(SESSION_CACHE_KEY, serialized);
    } catch (error) {
      console.debug("Admin inventory cache write skipped:", error?.message);
    }
  }
}
